import React, { useEffect, useRef } from 'react'
import html from '../assets/tech_img/html.svg'
import css from '../assets/tech_img/css3.svg'
import js from '../assets/tech_img/javascript.svg'
import ts from '../assets/tech_img/typescript.svg'
import react from '../assets/tech_img/react.svg'
import redux from '../assets/tech_img/redux.svg'
import node from '../assets/tech_img/nodejs.svg'
import express from '../assets/tech_img/express.svg'
import mongo from '../assets/tech_img/mongodb.svg'
import socket from '../assets/tech_img/socket.svg'
import mui from '../assets/tech_img/material-ui-1.svg'
import chakraui from '../assets/tech_img/icons8-chakra-ui.svg'
import netlify from '../assets/tech_img/netlify.svg'
import heroku from '../assets/tech_img/heroku.svg'
import styled from 'styled-components'
import AOS from "aos";
import "aos/dist/aos.css";

const SkillStyles = styled.section`
    .skill__container{
        row-gap: 3.5rem;
    }

    .skills__title{
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: .5rem;
        font-size: var(--small-font-size);
        font-weight: var(--font-semi-bold);
        margin-bottom: 2.5rem;
    }

    .skills__title i{
        font-size: 1rem;
        font-weight: initial;
    }

    .skills__info,
    .skills__data,
    .skills__blob{
        display: grid;
    }

    .skills__info{
        grid-template-columns: repeat(3,1fr);
        gap: 2.5rem 2rem;
    }

    .skills__data{
        justify-content: center;
        text-align: center;
    }

    .skills__blob{
        width: 80px;
        height: 80px;
        background-color: var(--container-color);
        border-radius: 3rem;
        place-items: center;
        margin-bottom: 1rem;
        transition: background 0.4s;
    }

    .skills__blob img{
        width: 40px;
    }

    .skills__name{
        font-size: var(--small-font-size);
        margin-bottom: .25rem;
    }

    .skills__subtitle{
        font-size: var(--tiny-font-size);
        color: var(--text-color-light);
    }

    .skills__blob:hover img{
        animation: bounce-skills .6s
    }

    @keyframes bounce-skills{
        0%{
            transform: translate(0);
        }
        20%{
            transform: translateY(-6px);
        }
        40%{
            transform: translate(0);
        }
        60%{
            transform: translateY(-3px);
        }
        80%{
            transform: translate(0);
        }
    }

    @media screen and (max-width: 340px){
        .container{
          margin-inline: 1rem;
        }
        .skills__info{
            grid-template-columns: repeat(2,1fr);
        }
    }
    @media screen and (min-width: 576px){
        .skills__container{
            justify-content: center;
        }
    }
    @media screen and (min-width: 767px){
        .skills__container{
            grid-template-columns: repeat(2,max-content);
            column-gap: 5rem;
        }
    }
    @media screen and (min-width: 1048px){
        .container{
            margin-inline: auto;
        }
    }
    @media screen and (min-width: 1200px){
        .skills__container{
            column-gap: 10rem;
        }
        .skills__title{
            margin-bottom: 3rem;
            font-size: 1.25rem;
            i{
                font-size: 1.45rem;
            }
        }
        .skills__name{
            font-size: var(--normal-font-size);
        }
        .skills__info{
            gap: 3rem;
        }
    }
`

function Skills({ menuref }) {

    const currref = useRef(null);

    useEffect(() => {
        AOS.init({
            delay: 0,
            duration: 1000,
        });
        AOS.refresh();
    }, [])

    const scrollActive = () => {
        const scrollY = window.pageYOffset;
        const sectionHeight = currref.current.offsetHeight;
        const sectionTop = currref.current.offsetTop - 58;
        // console.log(currref.current.id);
        const sectionId = currref.current.id;
        const sectionClass = menuref.current.querySelector('.nav__menu a[href*=' + sectionId + ']');

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
            sectionClass.classList.add('active-link');
        } else {
            sectionClass.classList.remove('active-link');
        }

    }
    useEffect(() => {
        window.addEventListener("scroll", scrollActive);
    }, [])
    return (
        <SkillStyles className='skills section' id='skills' ref={currref}>
            <h2 className="section__title">Skills</h2>
            <span className="section__subtitle">What I know</span>

            <div className="skills__container container grid section__border">

                {/* skill 1  */}
                <div className="skills__content" data-aos="fade-up-right">
                    <h3 className="skills__title">
                        <i className="ri-braces-line"></i> Frontend Skillset
                    </h3>

                    {/* frontend skillset  */}
                    <div className="skills__info">
                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={html} alt="html" />
                            </div>

                            <h3 className="skills__name">HTML</h3>
                            <span className="skills__subtitle">Advanced</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={css} alt="skills image" />
                            </div>

                            <h3 className="skills__name">CSS</h3>
                            <span className="skills__subtitle">Advanced</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={js} alt="skills image" />
                            </div>

                            <h3 className="skills__name">Javascript</h3>
                            <span className="skills__subtitle">Advanced</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={ts} alt="skills image" />
                            </div>

                            <h3 className="skills__name">Typescript</h3>
                            <span className="skills__subtitle">Basic</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={react} alt="skills image" />
                            </div>

                            <h3 className="skills__name">React</h3>
                            <span className="skills__subtitle">Intermediate</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={redux} alt="skills image" />
                            </div>

                            <h3 className="skills__name">Redux</h3>
                            <span className="skills__subtitle">Intermediate</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={mui} alt="skills image" />
                            </div>

                            <h3 className="skills__name">Material UI</h3>
                            <span className="skills__subtitle">Intermediate</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={chakraui} alt="skills image" />
                            </div>

                            <h3 className="skills__name">Chakra UI</h3>
                            <span className="skills__subtitle">Intermediate</span>
                        </div>
                    </div>
                </div>

                {/* skill 2  */}
                <div className="skills__content" data-aos="fade-up-left">
                    <h3 className="skills__title">
                        <i className="ri-terminal-window-line"></i>
                        {"Backend & Deployment"}
                    </h3>


                    <div className="skills__info">
                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={node} alt="node" />
                            </div>

                            <h3 className="skills__name">Node Js</h3>
                            <span className="skills__subtitle">Intermediate</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={express} alt="express" />
                            </div>

                            <h3 className="skills__name">Express JS</h3>
                            <span className="skills__subtitle">Intermediate</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={mongo} alt="mongodb" />
                            </div>

                            <h3 className="skills__name">Mongo DB</h3>
                            <span className="skills__subtitle">Intermediate</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={socket} alt="socket.io" />
                            </div>

                            <h3 className="skills__name">Socket.io</h3>
                            <span className="skills__subtitle">Beginner</span>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={netlify} alt="netlify" />
                            </div>

                            <h3 className="skills__name">Netlify</h3>
                        </div>

                        <div className="skills__data">
                            <div className="skills__blob">
                                <img src={heroku} alt="heroku" />
                            </div>

                            <h3 className="skills__name">Heroku</h3>
                        </div>
                    </div>
                </div>
            </div>
        </SkillStyles>
    )
}

export default Skills